<template>
    <div class="style-sub-item">
        <div class="sub-item-title" v-if="title" @click="toggleContent">
            <i class="el-icon-caret-right" :class="{ 'is-expanded': isExpanded }"></i>
            <span>{{ title }}</span>
        </div>
        <div :style="{ 'padding-top': !title || !isExpanded ? '0' : '12px' }" class="sub-item-content"
            :class="{ 'is-expanded': !title ? true : isExpanded }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'styleSubItem',
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isExpanded: false
        }
    },
    methods: {
        toggleContent() {
            this.isExpanded = !this.isExpanded
        }
    }
}
</script>

<style scoped lang="less">
.style-sub-item {
    background-color: #F7F7F7;
    padding: 9px 12px;
    min-height: 36px;
    border-radius: 4px;
    margin-bottom: 8px;

    .sub-item-title {
        color: var(--bi-jz-font-color);
        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        user-select: none;
        transition: all 0.2s ease;

        &:hover {
            color: #2e74ff;
        }

        i {
            margin-right: 6px;
            transition: transform 0.3s ease;
            font-size: 12px;

            &.is-expanded {
                transform: rotate(90deg);
            }
        }
    }

    .sub-item-content {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease, padding 0.3s ease;
        padding: 0;

        &.is-expanded {
            max-height: 1000px;
            padding: 12px 0 0 0;
        }
    }
}
</style>